import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import QuestionBox from '../../../question-box';
import './style.scss';

type Props = {
    onComplete?: () => void
}

const Task205: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-205');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-205">
        <h2>zadanie 5</h2>
        <h3>{task?.title}</h3>
        <p>Przedyskutujcie, co dla Was znaczy to stwierdzenie.</p>
        <p className="instruction"><strong>Zadanie:</strong> Z listy poniżej wybierzcie te sposoby działania, które staną się Waszymi metodami na wzmacnianie odporności na głupotę:</p>
        <div className="cards">
            <label>
                <input type="checkbox" />
                <p className="card">dyskutowanie z kolegami i koleżankami</p>
            </label>
            <label>
                <input type="checkbox" />
                <p className="card">szukanie wiedzy w Internecie i weryfikowanie źródeł</p>
            </label>
            <label>
                <input type="checkbox" />
                <p className="card">poszerzanie listy lektur</p>
            </label>
            <label>
                <input type="checkbox" />
                <p className="card">wsłuchiwanie się w racje stron przeciwnych</p>
            </label>
            <label>
                <input type="checkbox" />
                <p className="card">wspieranie się wiedzą autorytetów</p>
            </label>
            <label>
                <input type="checkbox" />
                <p className="card">uczenie się odróżniania faktów od opinii</p>
            </label>
        </div>
        <QuestionBox>
            <p>A może Wy macie pomysł na własny sposób na odporność na głupotę?</p>
        </QuestionBox>
    </div>
}

export default Task205;
